import { literal, string, struct } from 'io-ts/lib/Decoder';

/**
 * Sent when a segment is removed from a frame.
 * Server will recompute the frame geometry after removal.
 */
export const SegmentDeleted = struct({
	type: literal('segment-deleted'),
	frameId: string,
	segmentId: string,
});
